import { Link } from 'react-router-dom'

/** Paths starting with "/" route client-side; anything else (https:, mailto:) is a plain link. */
export default function Anchor({ href, ...props }) {
  return href.startsWith('/') ? (
    <Link to={href} {...props} />
  ) : (
    <a href={href} {...props} />
  )
}
